import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { InvoiceItemResponse } from '@api-client/mobipay';
import { ROUTES } from '@app/app.routes-constants';

@Injectable()
export class InvoiceNavigationService {
  protected readonly router = inject(Router);

  public navigateToInvoice(
    invoice: InvoiceItemResponse,
    context: 'inbound' | 'outbound'
  ): Promise<boolean> {
    if (!invoice?.id) {
      console.warn('Cannot navigate: Invalid invoice or missing ID');
      return Promise.resolve(false);
    }

    const navigationCommands = this.getNavigationCommands(invoice, context);
    if (!navigationCommands) {
      return Promise.resolve(false);
    }

    return this.router.navigate(navigationCommands);
  }

  private getNavigationCommands(
    invoice: InvoiceItemResponse,
    context: 'inbound' | 'outbound'
  ): unknown[] | null {
    switch (invoice.detailScreenType) {
      case 'TRANSACTION_INVOICE_EDIT':
        return [ROUTES.INVOICE.EDIT(context, invoice.id)];
      case 'FREE_INVOICE_EDIT':
        return [ROUTES.FREE_INVOICE.EDIT(invoice.id)];
      case 'GROUPED_INVOICE_EDIT':
        return [ROUTES.INVOICE.EDIT_GROUPED(context, invoice.id)];
      case 'CREDIT_NOTE_EDIT':
        return [ROUTES.CREDIT_NOTE.EDIT(invoice.id)];
      case 'INVOICE_DETAILS':
        return [ROUTES.INVOICE.DETAILS(context, invoice.id)];
      default:
        console.error('Unknown detail screen type:', invoice.detailScreenType);
        return null;
    }
  }
}